import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appFocusNext]',
  standalone: false
})
export class AppFocusNextDirective {

  @HostListener('keyup', ['$event']) onKeyDown(e) {
    e.preventDefault();
    if (e.srcElement.nextElementSibling) {
      e.srcElement.nextElementSibling.focus();
    }
    return;
  }
}
